import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function setQuotationSwiper() {
  const quotationSlider = new Swiper('[data-quotation] .swiper', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 4,
    speed: 1000,
    watchOverflow: true,
    centerInsufficientSlides: true,
    pagination: {
      el: '[data-quotation] .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '[data-quotation] .swiper-button-next',
      prevEl: '[data-quotation] .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 3,
      },
      1330: {
        slidesPerView: 4,
      },
    },
  });
}
